function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { boxShadow as getBoxShadow } from "../../ThemeProvider/cssFor";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(param, param1) {
    var backgroundColor = param.backgroundColor, depth = param.depth, font = param.font, animation = param.animation, borderColor = param.borderColor, size = param.size, experimentalBlocks = param.experimentalBlocks, start = param1.start, end = param1.end;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (animation === null || animation === void 0 ? void 0 : (ref = animation.productive) === null || ref === void 0 ? void 0 : ref.easeInOut) || {}, easing = ref6.easing, duration = ref6.duration;
    var fastest = (duration || {}).fastest;
    var boxShadow = getBoxShadow === null || getBoxShadow === void 0 ? void 0 : getBoxShadow(depth.boxShadow.hard);
    var _base, _base1, ref7;
    return {
        wrapper: {
            base: {}
        },
        button: {
            base: {
                border: 0,
                padding: 2,
                boxSizing: 'border-box',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 36,
                height: 36,
                textAlign: 'center',
                lineHeight: '36px',
                background: (_base = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.backgroundColor.neutral.base) !== null && _base !== void 0 ? _base : backgroundColor.neutral.base,
                borderRadius: size.border.radius.round,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: (_base1 = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : experimentalBlocks.font.color.neutral.base) !== null && _base1 !== void 0 ? _base1 : font.color.neutral.base,
                transition: "transform ".concat(fastest, " ").concat(easing, ", box-shadow ").concat(animation.duration[100], " ").concat(easing),
                transformOrigin: '50% 50%',
                boxShadow: boxShadow,
                cursor: 'pointer',
                '.js-focus-visible &:focus:not(.focus-visible)': {
                    boxShadow: boxShadow
                },
                '.js-focus-visible &:focus': {
                    outline: 0,
                    boxShadow: "".concat(boxShadow, ", 0 0 0 2px ").concat(borderColor.interactive.focus)
                },
                '&:active': {
                    transform: 'translateY(-50%) scale(1.03)'
                },
                '@media (hover)': {
                    opacity: 0,
                    'div:hover > &': {
                        opacity: 1
                    },
                    '&:focus': {
                        opacity: 1
                    }
                }
            },
            inset: {
                width: 24,
                height: 24
            },
            next: _defineProperty({}, end.direction, 0),
            previous: _defineProperty({}, start.direction, 0),
            insetNext: _defineProperty({}, end.direction, 4),
            insetPrevious: _defineProperty({}, start.direction, 4)
        },
        icon: {
            base: {
                color: (ref7 = experimentalBlocks === null || experimentalBlocks === void 0 ? void 0 : (ref1 = experimentalBlocks.font) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.color) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.neutral) === null || ref3 === void 0 ? void 0 : ref3.base) !== null && ref7 !== void 0 ? ref7 : font === null || font === void 0 ? void 0 : (ref4 = font.color) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.neutral) === null || ref5 === void 0 ? void 0 : ref5.base
            }
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl, insetControls = param.insetControls, controlsVerticalPosition = param.controlsVerticalPosition;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle || !(builtStyle.wrapper && builtStyle.button && builtStyle.icon)) {
        return {
            wrapper: {},
            nextButton: {},
            previousButton: {},
            icon: {
                color: {}
            }
        };
    }
    var wrapper = builtStyle.wrapper, button = builtStyle.button, icon = builtStyle.icon;
    var controlsPosition = controlsVerticalPosition !== null && typeof controlsVerticalPosition !== 'undefined' ? {
        top: controlsVerticalPosition
    } : {};
    return {
        wrapper: _objectSpread({}, wrapper.base),
        nextButton: _objectSpread({}, button.base, button.next, insetControls && button.inset, insetControls && button.insetNext, controlsPosition),
        previousButton: _objectSpread({}, button.base, button.previous, insetControls && button.inset, insetControls && button.insetPrevious, controlsPosition),
        icon: _objectSpread({}, icon.base)
    };
};
export default useStyle;
